<template>
<section>
    <section class="im">
        <div class="home-im">
            <img src="../assets/images/home-im.png" alt="">
        </div>
        <div class="im-arrow">
            <img src="../assets/images/im-arrow.png" alt="">
        </div>
        <div class="home-close" @click="close">
            亲爱的玩家：<br />您可以在此选择问题分类，进行问题提交。
            <img src="../assets/images/home-close.png" alt="">
        </div>
    </section>

    <div class="cover"></div>
</section>
</template>

<script>
export default {
    methods: {
        close() {
            this.$emit('input', false);
            window.sessionStorage.imOffline = '1';
        }
    }
};
</script>

<style lang="scss" scoped>
.im {
  position: fixed;
  top: 316px;
  z-index: 200;

  .home-im {
  }

  .im-arrow {
      width: 64px;
      height: 64px;
      margin: 0 auto;
  }

  .home-close {
    width: 450px;
    height: 282px;
    z-index: 200;
    box-sizing: border-box;
    padding: 30px 40px;
    background: white;
    font-size: 32px;
    font-weight: bold;
    line-height: 1.3;
    margin: -18px auto 0;
    border-radius: 6px;
    img {
        height: 64px;
        margin-top: 32px;
    }
  }
}

.cover {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: black;
  opacity: 0.6;
  z-index: 100;
}
</style>
